import React, { useRef, useState } from "react";
import HandleClickOutside from "../../utils/helpers/HandleOutsideClick";

const formatResponseTime = (ms) => {
  if (typeof ms !== "number") return "";
  return ms < 1000 ? `${Math.round(ms)}ms` : `${(ms / 1000).toFixed(1)}s`;
};

const ModelDropdown = ({ modelslist, activeModel, setActiveModel, models }) => {
  const ref = useRef();
  const [showDropdown, setShowDropdown] = useState(false);
  const handleModelSelect = (option) => {


    let finalOption = modelslist?.find((item) => item?.value === option);
  
   

    setActiveModel(finalOption);
    setShowDropdown(false);
   
  };
  HandleClickOutside(ref, () => {
    setShowDropdown(false);
  });

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setShowDropdown(!showDropdown)}
        className="flex items-center justify-between gap-1 bg-white text-black px-2 py-1.5 border border-[#DCDCDC] rounded-[100px] text-[13px] w-[150px]"
      >
        <span className="truncate">
          {activeModel?.name}
          {models?.[activeModel?.value]?.responseTimeMs != null && (
            <span className="text-[11px] text-gray-400">
              {" "}
              · {formatResponseTime(models[activeModel.value].responseTimeMs)}
            </span>
          )}
        </span>
        <svg
          className="w-4 h-4"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {showDropdown && (
        <ul
          className={`absolute top-full left-0 mt-1 w-[190px] bg-white text-black border border-gray-300 rounded-md shadow-lg z-20 max-h-[220px] overflow-auto text-[13px]`}
        >
          {modelslist.map((item, index) => {
            const modelState = models?.[item.value];
            const status = modelState?.status;
            const isSelectable = status === "done";
            return (
              <li
                key={index}
                className={`px-4 py-2 flex items-center justify-between gap-2 ${
                  isSelectable
                    ? "hover:bg-gray-100 cursor-pointer"
                    : "text-gray-400 italic cursor-default"
                } ${activeModel?.value === item.value ? "bg-gray-100" : ""}`}
                onClick={() => isSelectable && handleModelSelect(item.value)}
              >
                <span>{item.name}</span>
                {status === "pending" && (
                  <span className="text-[11px]">Generating...</span>
                )}
                {status === "error" && (
                  <span className="text-[11px] text-red-400">Unavailable</span>
                )}
                {status === "done" && (
                  <span className="text-[11px] text-gray-400">
                    {formatResponseTime(modelState.responseTimeMs)}
                  </span>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default ModelDropdown;
